// 语音标记状态
export enum EVoiceBtnStatusType {
    ON = 'on',
    OFF = 'off'
}

// 复制标记状态
export enum ECopyBtnStatusType {
    COPY = 'copy',
    SUCCESS = 'success'
}

// 联系人身份
export enum EContactIdentityType {
    FATHER = '爸爸',
    MOTHER = '妈妈',
    HUSBAND = '老公',
    WIFE = '老婆',
    SON = '儿子',
    DAUGHTER = '女儿',
    OTHER = '其他'
}